module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/instagram/chapel_sns_02-6ddeacd70b77bdb241f6fda04f4757fb.jpg";